import React, { useState, useEffect, useContext } from 'react';
import {
  Button, TextField, MenuItem, IconButton, Modal
} from '@mui/material';
import {
  ChevronRight, ExpandMore
} from '@mui/icons-material';
import {
  faFolderOpen, faLock, faTrash, faSearch, faFolder, faFilePdf, faFileWord,
  faFileImage, faFileVideo, faFileCode, faFile, faTimes, faUnlock,
  faAustralSign
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFolder, deleteFileFolder, encryptFileFolder, decryptFileFolder } from '../../apis/agent';
import { getCompanyDevices, editLastLogin, addQueueOperation, addOperation ,requestOperation ,checkValid} from '../../apis/axios';
import ConfirmDialog from '../common/ConfirmationModal';
import AuthContext from '../../AuthContext';
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import axios from 'axios'; // Added axios import
import { toast } from 'react-toastify';
// Define token (adjust based on your auth setup)
const token = localStorage.getItem('token') || '';

const FileExplorerCard = ({ uuid, sys_uuid, data, setPathCurrent, onFileChange ,device_id,disabled ,licence_id}) => { // Added sys_uuid to props
  const auth = useContext(AuthContext);
  const [fileData, setFileData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info"); // "error" | "success" | "warning"
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [currentPath, setCurrentPath] = useState([]);
  const [sortBy, setSortBy] = useState('Name (A-Z)');
  const [openFolders, setOpenFolders] = useState({});
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingItems, setLoadingItems] = useState({});
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState('encrypt');
  const [password, setPassword] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [canDecrypt, setCanDecrypt] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [pathBeforeOperation, setPathBeforeOperation] = useState([]);
  const [openRequest,setOpenRequest]=useState(false)
  const deviceId=device_id;
  //console.log(deviceId)
  // Moved mapApiResponseToFileData above useEffect to prevent initialization error
  const mapApiResponseToFileData = (response) => {
    const folderName = response.path.split('\\').pop() || 'Root';
    const folders = response.folders.map(folder => ({
      name: folder,
      isFolder: true,
      children: [],
      path: response.path ? `${response.path}\\${folder}` : folder,
    }));
    const files = response.files.map(file => ({
      name: file.name,
      isFolder: false,
      type: inferFileType(file.name),
      size: formatFileSize(file.size_bytes),
      modified: formatDate(file.last_modified),
      status: file.name.toLowerCase().endsWith('.enc') ? 'Encrypted' : 'Normal',
      path: response.path ? `${response.path}\\${file.name}` : file.name,
    }));
    return {
      name: folderName,
      isFolder: true,
      children: [...folders, ...files],
      path: response.path || '',
    };
  };
     const checkLicence = async () => {
    try {
      const res = await checkValid({ licence_id }); // your API call
      //console.log(res.data);

      if (res.data.status === "limit_exceeded") {
        setSnackbarMsg("Licence limit exceeded");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      } else {
        setOpenDeleteConfirm(true)
      }
    } catch (error) {
      console.error(error);
      setSnackbarMsg(error?.response?.data?.error || "Something went wrong");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };


  useEffect(() => {
    const storedUser = localStorage.getItem('user');

    
  }, [auth]);

  useEffect(() => {
    if (data) {
      const mappedData = mapApiResponseToFileData(data);
      setFileData(mappedData);
      setCurrentPath([mappedData]);
      setOpenFolders({ [mappedData.name]: true });
    }
  }, [data]);
  const currentFolder = currentPath[currentPath.length - 1] || {};
  const currentFiles = currentFolder.children || [];

  const filteredFiles = currentFiles
    .filter(item => {
      return item.name.toLowerCase().includes(searchTerm.toLowerCase());
    })
    .sort((a, b) => {
      if (a.isFolder && !b.isFolder) return -1;
      if (!a.isFolder && b.isFolder) return 1;
      switch (sortBy) {
        case 'Name (A-Z)':
          return a.name.localeCompare(b.name);
        case 'Name (Z-A)':
          return b.name.localeCompare(a.name);
        case 'Size (Largest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseSizeToBytes(b.size) - parseSizeToBytes(a.size);
        case 'Size (Smallest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseSizeToBytes(a.size) - parseSizeToBytes(b.size);
        case 'Modified (Newest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseDate(b.modified).getTime() - parseDate(a.modified).getTime();
        case 'Modified (Oldest First)':
          if (a.isFolder && b.isFolder) return a.name.localeCompare(b.name);
          return parseDate(a.modified).getTime() - parseDate(b.modified).getTime();
        default:
          return a.name.localeCompare(b.name);
      }
    });

  useEffect(() => {
    const selectedItems = (currentFolder.children || []).filter(item => selectedFiles.includes(item.name));
    const canDecryptFiles = selectedItems.length > 0 &&
      selectedItems.every(item => !item.isFolder && item.status === 'Encrypted');
    setCanDecrypt(canDecryptFiles);
  }, [selectedFiles, currentFolder]);

  useEffect(() => {
    const allSelected = filteredFiles.length > 0 && filteredFiles.every(item => selectedFiles.includes(item.name));
    setIsAllSelected(allSelected);
  }, [filteredFiles, selectedFiles]);

  if (!auth.isLoggedIn || !auth.user) {
    return (
      <div className="bg-white p-4 md:p-6 shadow-lg rounded-xl border border-gray-100" style={{ fontFamily: 'Nunito Sans, sans-serif' }}>
        <h2 className="text-xl font-bold flex items-center gap-3 text-gray-800 mb-6">
          <FontAwesomeIcon icon={faFolderOpen} className="text-[#FF7A00]" />
          File Explorer
        </h2>
        <div style={{ textAlign: 'center', color: '#E74C3C' }}>
          User not logged in. Please log in to access the file explorer.
        </div>
      </div>
    );
  }

  const openModalHandler = (mode) => {
    setModalMode(mode);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setPassword('');
  };

  const formatFileSize = (bytes) => {
    if (bytes === 'Unknown' || bytes == null) return 'Unknown';
    const kb = bytes / 1024;
    const mb = kb / 1024;
    const gb = mb / 1024;
    const formatNumber = (num) => {
      const integerPart = Math.floor(num);
      const integerDigits = integerPart.toString().length;
      let formatted;
      if (integerDigits >= 3) {
        formatted = num.toFixed(1);
      } else if (integerDigits === 2) {
        formatted = num.toFixed(2);
      } else {
        formatted = num.toFixed(3);
      }
      return Number(formatted).toString();
    };
    if (gb >= 1) {
      return `${formatNumber(gb)} GB`;
    } else if (mb >= 1) {
      const mbIntegerPart = Math.floor(mb);
      if (mbIntegerPart.toString().length >= 4) {
        return `${formatNumber(gb)} GB`;
      }
      return `${formatNumber(mb)} MB`;
    } else {
      const kbIntegerPart = Math.floor(kb);
      if (kbIntegerPart.toString().length >= 4) {
        return `${formatNumber(mb)} MB`;
      }
      return `${formatNumber(kb)} KB`;
    }
  };

  const parseSizeToBytes = (size) => {
    if (size === '--') return 0;
    const [value, unit] = size.split(' ');
    const num = parseFloat(value);
    if (unit === 'GB') return num * 1024 * 1024 * 1024;
    if (unit === 'MB') return num * 1024 * 1024;
    if (unit === 'KB') return num * 1024;
    return 0;
  };

  const formatDate = (dateString) => {
    if (dateString === 'Unknown' || !dateString) return 'Unknown';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Unknown';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, '0');
    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${period}`;
  };

  const parseDate = (dateString) => {
    if (dateString === '--' || dateString === 'Unknown') return new Date(0);
    const [datePart, timePart, period] = dateString.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    let [hours, minutes] = timePart.split(':').map(Number);
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    const fullYear = 2000 + year;
    const date = new Date(fullYear, month - 1, day, hours, minutes);
    return date;
  };

  const inferFileType = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'gitignore':
      case 'sqlite3':
        return 'System File';
      case 'zip':
      case 'txt':
        return 'Document';
      case 'py':
      case 'ps1':
        return 'Executable';
      case 'pdf':
        return 'PDF';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'Image';
      case 'mp4':
      case 'avi':
      case 'mkv':
        return 'Video';
      case 'xml':
        return 'XML';
      case 'enc':
        return 'Encrypted File';
      default:
        return 'File';
    }
  };

  const fetchSubFolder = async (folderNode) => {
    try {
      const newPath = folderNode.path;
      setPathCurrent(newPath.replace(/[\\/]/g, '\\\\'));
      setLoading(true);
      const response = await getFolder(uuid, newPath, sys_uuid); // Add sys_uuid to getFolder call
      const mappedData = mapApiResponseToFileData(response.data);
      return mappedData.children;
    } catch (err) {
      setError(`Failed to load contents of folder ${folderNode.name}.`);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (name) => {
    setSelectedFiles((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };

  const encryptFilesInFolder = (folder) => {
    if (!folder.children) return;
    folder.children.forEach(item => {
      if (item.isFolder) {
        encryptFilesInFolder(item);
      } else {
        item.status = 'Encrypted';
      }
    });
  };

  const restorePathAfterRefresh = async (pathToRestore) => {
    if (!pathToRestore || pathToRestore.length === 0) return;

    try {
      setLoading(true);
      let currentNode = fileData;
      const newPath = [currentNode];
      const newOpenFolders = { ...openFolders, [currentNode.name]: true };

      for (let i = 1; i < pathToRestore.length; i++) {
        const folderName = pathToRestore[i].name;
        const folderNode = currentNode.children.find(child => child.isFolder && child.name === folderName);

        if (!folderNode) {
          setError(`Failed to restore path: Folder ${folderName} not found.`);
          break;
        }

        folderNode.children = await fetchSubFolder(folderNode);
        newPath.push(folderNode);
        newOpenFolders[folderName] = true;
        currentNode = folderNode;
      }

      setCurrentPath(newPath);
      setOpenFolders(newOpenFolders);
    } catch (err) {
      setError('Failed to restore the previous path after refresh.');
    } finally {
      setLoading(false);
    }
  };

  const handleEncrypt = () => {
    if (selectedFiles.length === 0) {
      setError('No files selected for encryption.');
      return;
    }
    openModalHandler('encrypt');
  };

  const handleDecrypt = () => {
    if (selectedFiles.length === 0) {
      setError('No files selected for decryption.');
      return;
    }
    openModalHandler('decrypt');
  };

  const checkDeviceStatus = async () => {
    try {
      const companyId = auth.admin || '';
      if (!companyId) {
        throw new Error('companyId is empty or undefined.');
      }
      if (!uuid) {
        throw new Error('uuid is empty or undefined.');
      }

      

      const deviceResponse = await getCompanyDevices({ company_id: companyId });

      if (deviceResponse && Array.isArray(deviceResponse.data)) {
        const device = deviceResponse.data.find(dev => dev.uuid === uuid);
        if (!device) {
          throw new Error('Device not found.');
        }
        if (!device.id) {
          throw new Error('Device found but id is missing.');
        }

     
        const payload = {
          id: deviceId,
          uuid: uuid,
        };
        const statusResponse = await editLastLogin(payload);
        //console.log("editLastLogin response:", statusResponse.data.isActive);
        const isActive = statusResponse.data.isActive === 1;

        return { isActive, deviceId };
      } else {
        throw new Error('Invalid response from getCompanyDevices.');
      }
    } catch (err) {
      setError('Failed to verify device status. Please ensure the device is registered and try again.');
      return { isActive: false, deviceId: null };
    }
  };

  const handleConfirmEncrypt = async () => {
    if (!password) {
      setError('Encryption password is required.');
      return;
    }
    if (selectedFiles.length === 0) {
      setError('No files selected for encryption.');
      return;
    }

    setPathBeforeOperation([...currentPath]);
    closeModal();

    try {
      setLoadingItems(prev => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach(name => {
          newLoadingItems[name] = true;
        });
        return newLoadingItems;
      });
      setError(null);

      const { isActive, deviceId } = await checkDeviceStatus();

      const pathsToEncrypt = selectedFiles.map(name => {
        const item = currentFolder.children.find(item => item.name === name);
        return item.path.replace(/[\\/]/g, '\\\\');
      });

      if (isActive) {
        const operationPromises = pathsToEncrypt.map(async (path) => {
          const operationData = {
            device_id: deviceId,
            user_id: auth.user,
            type: 'encryption',
            json: {
              path: path,
              password: password,
            },
          };
          const operationResponse = await requestOperation(operationData);
          setOpenRequest(true)
          const operationLogId = operationResponse.data.log_id;

          if (!operationLogId) {
            throw new Error("No log_id returned from addOperation");
          }

          await encryptFileFolder(uuid, path, password, operationLogId, sys_uuid); // Add sys_uuid to encryptFileFolder call
        });

        await Promise.all(operationPromises);

        const updatedData = { ...fileData };
        const files = currentFolder.children;
        files.forEach(item => {
          if (selectedFiles.includes(item.name)) {
            if (item.isFolder) {
              encryptFilesInFolder(item);
            } else {
              item.status = 'Encrypted';
              if (!item.name.toLowerCase().endsWith('.enc')) {
                item.name = `${item.name}.enc`;
                item.path = `${item.path}.enc`;
                item.type = inferFileType(item.name);
              }
            }
          }
        });
        setFileData(updatedData);
        setCurrentPath(prev => [...prev.map(folder => ({ ...folder }))]);
        setSelectedFiles([]);
        if (onFileChange) {
          await onFileChange();
          await restorePathAfterRefresh(pathBeforeOperation);
        }
        // Clear error on successful encryption
        setError(null);
      } else {
        const userId = auth.user;
        if (!userId) {
          throw new Error('User ID not found. Please log in again.');
        }
       

        const queuePromises = pathsToEncrypt.map(async (path) => {
          const operationData = {
            device_id: device_id,
            user_id: userId,
            type: 'encryption',
            json: {
              path: path,
              password: password,
            },
          };
          
          const queueResponse = await requestOperation(operationData);
          setOpenRequest(true)
          const queueLogId = queueResponse.data.log_id;

          if (!queueLogId) {
            throw new Error("No log_id returned from addQueueOperation");
          }
        });

        await Promise.all(queuePromises);

        setError('Device is offline. Encryption operation has been queued.');
        setSelectedFiles([]);
      }
    } catch (err) {
      setError(err.message || 'Failed to process encryption. Please try again.');
    } finally {
      setLoadingItems(prev => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach(name => {
          newLoadingItems[name] = false;
        });
        return newLoadingItems;
      });
      setPathBeforeOperation([]);
    }
  };

  const handleConfirmDecrypt = async () => {
    if (!password) {
      setError('Decryption password is required.');
      return;
    }
    if (selectedFiles.length === 0) {
      setError('No files selected for decryption.');
      return;
    }

    setPathBeforeOperation([...currentPath]);
    closeModal();

    try {
      setLoadingItems(prev => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach(name => {
          newLoadingItems[name] = true;
        });
        return newLoadingItems;
      });
      setError(null);

      const { isActive} = await checkDeviceStatus();

      const pathsToDecrypt = selectedFiles.map(name => {
        const item = currentFolder.children.find(item => item.name === name);
        return item.path.replace(/[\\/]/g, '\\\\');
      });

      if (isActive) {
        const operationPromises = pathsToDecrypt.map(async (path) => {
          const operationData = {
            device_id: deviceId,
            user_id: auth.user,
            type: 'decryption',
            json: {
              path: path,
              password: password,
            },
          };
          const operationResponse = await requestOperation(operationData);
          setOpenRequest(true)
          const operationLogId = operationResponse.data.log_id;

          if (!operationLogId) {
            throw new Error("No log_id returned from addOperation");
          }

          await decryptFileFolder(uuid, path, password, operationLogId, sys_uuid); // Add sys_uuid to decryptFileFolder call
        });

        await Promise.all(operationPromises);

        const updatedData = { ...fileData };
        const files = currentFolder.children;
        files.forEach(item => {
          if (selectedFiles.includes(item.name)) {
            item.status = 'Normal';
            if (item.name.toLowerCase().endsWith('.enc')) {
              item.name = item.name.substring(0, item.name.length - 4);
              item.path = item.path.substring(0, item.path.length - 4);
              item.type = inferFileType(item.name);
            }
          }
        });
        setFileData(updatedData);
        setCurrentPath(prev => [...prev.map(folder => ({ ...folder }))]);
        setSelectedFiles([]);
        if (onFileChange) {
          await onFileChange();
          await restorePathAfterRefresh(pathBeforeOperation);
        }
        // Clear error on successful decryption
        setError(null);
      } else {
        const userId = auth.user;
        if (!userId) {
          throw new Error('User ID not found. Please log in again.');
        }
       

        const queuePromises = pathsToDecrypt.map(async (path) => {
          const operationData = {
            device_id: device_id,
            user_id: userId,
            type: 'decryption',
            json: {
              path: path,
              password: password,
            },
          };
          const queueResponse = await requestOperation(operationData);
          setOpenRequest(true)
          const queueLogId = queueResponse.data.log_id;

          if (!queueLogId) {
            throw new Error("No log_id returned from addQueueOperation");
          }
        });

        await Promise.all(queuePromises);

        setError('Device is offline. Decryption operation has been queued.');
        setSelectedFiles([]);
      }
    } catch (err) {
      setError(err.message || 'Failed to process decryption. Please try again.');
    } finally {
      setLoadingItems(prev => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach(name => {
          newLoadingItems[name] = false;
        });
        return newLoadingItems;
      });
      setPathBeforeOperation([]);
    }
  };

  const handleDelete = () => {
    if (selectedFiles.length === 0) {
      setError('No files selected for deletion.');
      return;
     
    }
    else{
       checkLicence()      
    }

    
  };
  const handleSendRequest=()=>{
   setOpenRequest(true)
  }
  const handleConfirmDelete = async () => {
    const updatedData = { ...fileData };
    const pathsToDelete = selectedFiles.map(name => {
      const item = currentFolder.children.find(item => item.name === name);
      return item.path;
    });
    
    setPathBeforeOperation([...currentPath]);
    setOpenDeleteConfirm(false);

    try {
      setLoadingItems(prev => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach(name => {
          newLoadingItems[name] = true;
        });
        return newLoadingItems;
      });
      setError(null);



      const { isActive } = await checkDeviceStatus();

      if (isActive) {
        const operationPromises = pathsToDelete.map(async (path) => {
          const formattedPath = path.replace(/[\\/]/g, '\\\\');
          setOpenDeleteConfirm(false)
          const operationData = {
            device_id: device_id,
            user_id: auth.user,
            type: 'delete_file/folder',
            json: {
              path: formattedPath,
            }, 
          };
          const operationResponse = await requestOperation(operationData);
          
          setOpenRequest(true)
          if(operationResponse.data.success===false){
            setError(operationResponse.data.error || 'Failed to delete selected items.');
            throw new Error(operationResponse.data.error || 'Failed to delete selected items.');
          }
          const operationLogId = operationResponse.data.log_id;

          if (!operationLogId) {
            throw new Error("No log_id returned from addOperation");
          }
        });

        await Promise.all(operationPromises);

        currentFolder.children = currentFolder.children.filter(item => !selectedFiles.includes(item.name));
        setFileData(updatedData);
        setCurrentPath(prev => [...prev.map(folder => ({ ...folder }))]);
        setSelectedFiles([]);
        if (onFileChange) {
          await onFileChange();
          await restorePathAfterRefresh(pathBeforeOperation);
        }
        // Clear error on successful deletion
        setError(null);
      } else {
        const userId = auth.user;
        if (!userId) {
          throw new Error('User ID not found. Please log in again.');
        }
        if (!device_id) {
          throw new Error('Device ID not found. Cannot queue operation.');
        }

        const queuePromises = pathsToDelete.map(async (path) => {
          const formattedPath = path.replace(/[\\/]/g, '\\\\');
          const operationData = {
            device_id: device_id,
            user_id: userId,
            type: 'delete_file/folder',
            json: {
              path: formattedPath,
            },
          };
          const queueResponse = await requestOperation(operationData);
          setOpenRequest(true)
          const queueLogId = queueResponse.data.log_id;

          if (!queueLogId) {
            throw new Error("No log_id returned from addQueueOperation");
          }
        });

        await Promise.all(queuePromises);

        setError('Device is offline. Deletion operation has been queued.');
        setSelectedFiles([]);
      }
    } catch (err) {
      setError('Failed to delete selected items.');
    } finally {
      setLoadingItems(prev => {
        const newLoadingItems = { ...prev };
        selectedFiles.forEach(name => {
          newLoadingItems[name] = false;
        });
        return newLoadingItems;
      });
      setPathBeforeOperation([]);
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirm(false);
  };

  const toggleFolder = async (folderNode) => {
    const folderName = folderNode.name;
    setOpenFolders(prev => {
      const isOpen = !prev[folderName];
      return { ...prev, [folderName]: isOpen };
    });
    if (!openFolders[folderName]) {
      try {
        const subFolderContents = await fetchSubFolder(folderNode);
        folderNode.children = subFolderContents;
        setCurrentPath(prev => {
          const index = prev.findIndex(f => f.name === folderName);
          if (index === -1 || index === prev.length - 1) {
            return [...prev, folderNode];
          }
          return prev.slice(0, index + 1).concat([folderNode]);
        });
        // Clear the error on successful folder fetch
        setError(null);
      } catch (err) {
        // Error is already set by fetchSubFolder; no need to set it again
      }
    } else {
      setCurrentPath(prev => {
        const index = prev.findIndex(f => f.name === folderName);
        if (index !== -1 && index < prev.length - 1) {
          return prev.slice(0, index + 1);
        }
        return prev;
      });
      // Clear the error when closing a folder or navigating up
      setError(null);
    }
    setSelectedFiles([]);
  };

  const getIconForItem = (item) => {
    if (item.isFolder) {
      return faFolder;
    }
    switch (item.type) {
      case 'PDF':
        return faFilePdf;
      case 'Document':
        return faFileWord;
      case 'Image':
        return faFileImage;
      case 'Video':
        return faFileVideo;
      case 'Executable':
        return faFileCode;
      case 'Encrypted File':
        return faLock;
      case 'System File':
      case 'XML':
      default:
        return faFile;
    }
  };

  const FileNode = ({ node, level = 0 }) => {
    if (!node.isFolder) return null;
    const hasChildren = node.children?.some(child => child.isFolder);
    const isOpen = openFolders[node.name] || false;
    const handleClick = () => {
      toggleFolder(node);
    };
    return (
      <div>
        <div
          className="flex items-center gap-2 py-1 text-gray-700 hover:bg-orange-50 rounded cursor-pointer whitespace-nowrap"
          style={{ paddingLeft: `${level * 16}px` }}
          onClick={handleClick}
        >
          {hasChildren ? (
            <IconButton size="small">
              {isOpen ? <ExpandMore fontSize="small" /> : <ChevronRight fontSize="small" />}
            </IconButton>
          ) : (
            <span className="w-6 inline-block" />
          )}
          <FontAwesomeIcon icon={isOpen ? faFolderOpen : faFolder} className="text-[#FF6B00]" />
          <span className="text-sm truncate">{node.name}</span>
        </div>
        {isOpen && hasChildren && (
          <div>
            {node.children
              .filter(child => child.isFolder)
              .map((child, index) => (
                <FileNode key={child.name} node={child} level={level + 1} />
              ))}
          </div>
        )}
      </div>
    );
  };

  if (error && !fileData) {
    return (
      <div className="bg-white p-4 md:p-6 shadow-lg rounded-xl border border-gray-100" style={{ fontFamily: 'Nunito Sans, sans-serif' }}>
        <h2 className="text-xl font-bold flex items-center gap-3 text-gray-800 mb-6">
          <FontAwesomeIcon icon={faFolderOpen} className="text-[#FF7A00]" />
          File Explorer
        </h2>
        <div style={{ textAlign: 'center', color: '#E74C3C' }}>
          {error}
        </div>
      </div>
    );
  }

  if (!fileData) {
    return (
      <div className="bg-white p-4 md:p-6 shadow-lg rounded-xl border border-gray-100" style={{ fontFamily: 'Nunito Sans, sans-serif' }}>
        <h2 className="text-xl font-bold flex items-center gap-3 text-gray-800 mb-6">
          <FontAwesomeIcon icon={faFolderOpen} className="text-[#FF7A00]" />
          File Explorer
        </h2>
        <div style={{ textAlign: 'center', color: '#595C60' }}>
          No folder data available.
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-4 md:p-6 shadow-lg rounded-xl border border-gray-100" style={{ fontFamily: 'Nunito Sans, sans-serif' }}>
      <div className="flex justify-between items-center mb-6 flex-wrap gap-4">
        <h2 className="text-xl font-bold flex items-center gap-3 text-gray-800">
          <FontAwesomeIcon icon={faFolderOpen} className="text-[#FF7A00]" />
          File Explorer
        </h2>
      </div>

      <div className="flex justify-between items-center mb-5 flex-wrap gap-4">
        <div className="flex gap-4 flex-wrap">
          <Button
            onClick={handleEncrypt}
            variant="contained"
            style={{
              backgroundColor: '#FF7A00',
              borderRadius: '5px',
              textTransform: 'none',
              fontSize: '14px',
              padding: '2px 16px',
              fontFamily: 'Nunito Sans, sans-serif',
            }}
          >
            <FontAwesomeIcon icon={faLock} className="mr-2" />
            Encrypt Selected
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            disabled={disabled}
            style={{
              backgroundColor: '#E74C3C',
              borderRadius: '5px',
              textTransform: 'none',
              fontSize: '14px',
              padding: '2px 16px',
              fontFamily: 'Nunito Sans, sans-serif',
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-2" />
            Delete Selected
          </Button>
          <Button
            onClick={handleDecrypt}
            variant="outlined"
            disabled={!canDecrypt}
            style={{
              borderRadius: '5px',
              textTransform: 'none',
              fontSize: '14px',
              padding: '2px 16px',
              color: canDecrypt ? '#000' : '#999',
              borderColor: canDecrypt ? '#000' : '#999',
              fontFamily: 'Nunito Sans, sans-serif',
            }}
          >
            <FontAwesomeIcon icon={faUnlock} className="mr-2" />
            Decrypt Selected
          </Button>
        </div>

        <div className="flex gap-3 flex-wrap items-center">
          <div className="relative">
            <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3.5 h-3.5" />
            <input
              type="text"
              placeholder="Search Files"
              className="pl-9 pr-3 border text-sm border-gray-300 rounded focus:ring-2 focus:ring-orange-400 focus:outline-none"
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                height: '31px',
                padding: '0 12px 0 36px',
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <TextField
            select
            size="small"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            variant="outlined"
            className="min-w-[120px] w-full sm:w-auto"
            sx={{
              fontSize: '0.875rem',
              fontWeight: 500,
              color: '#202224',
              border: '0.6px solid #202224',
              backgroundColor: '#FCFDFD',
              borderRadius: '6px',
              height: '31px',
              width: '150px',
              fontFamily: 'Nunito Sans, sans-serif',
              '& .MuiSelect-select': {
                padding: '0 32px 0 12px',
                paddingRight: '32px !important',
                lineHeight: '31px',
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
                height: '31px',
                fontSize: '0.875rem',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              '&:focus-within': {
                borderColor: '#FF6B00',
              },
              '& .MuiSelect-icon': {
                color: '#202224',
                fontSize: '18px',
              },
              '& .MuiInputBase-root': {
                fontSize: '0.875rem',
              },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root': {
                      fontSize: '0.875rem',
                      color: '#202224',
                      fontFamily: 'Nunito Sans, sans-serif',
                      '&:hover': {
                        backgroundColor: '#FFF3E5',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#FF6B00',
                        color: '#FFFFFF',
                        '&:hover': {
                          backgroundColor: '#FF6B00',
                          color: '#FFFFFF',
                        },
                      },
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="Name (A-Z)">Name (A-Z)</MenuItem>
            <MenuItem value="Name (Z-A)">Name (Z-A)</MenuItem>
            <MenuItem value="Size (Largest First)">Size (Largest First)</MenuItem>
            <MenuItem value="Size (Smallest First)">Size (Smallest First)</MenuItem>
            <MenuItem value="Modified (Newest First)">Modified (Newest First)</MenuItem>
            <MenuItem value="Modified (Oldest First)">Modified (Oldest First)</MenuItem>
          </TextField>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-6 md:gap-8 flex-wrap">
        <div className="w-full md:w-[220px] overflow-x-auto border-r border-gray-200 pr-2">
          <div className="min-w-max">
            <FileNode node={fileData} />
          </div>
        </div>

        <div className="flex-1 overflow-auto">
          {loading ? (
            <div className="flex justify-center items-center h-32">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="min-w-[500px]">
              <div className="flex items-center bg-gray-50 rounded-t-lg px-6 py-3 text-sm font-bold" style={{ color: '#202224' }}>
                <div className="w-6 mr-2">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={() => {
                      setIsAllSelected(prev => {
                        const newState = !prev;
                        if (newState) {
                          setSelectedFiles(filteredFiles.map(item => item.name));
                        } else {
                          setSelectedFiles([]);
                        }
                        return newState;
                      });
                    }}
                    className="custom-checkbox"
                  />
                </div>
                <div className="w-1/3">Name</div>
                <div className="w-1/6">Type</div>
                <div className="w-1/6">Size</div>
                <div className="w-1/3">Modified</div>
                <div className="w-[5%]">Status</div>
              </div>

              {filteredFiles.map((item, i) => (
                <div key={i} className="relative flex items-center px-6 py-2 text-sm hover:bg-orange-50" style={{ color: '#202224' }}>
                  <div className="w-6 mr-2">
                    <input
                      type="checkbox"
                      checked={selectedFiles.includes(item.name)}
                      onChange={() => handleSelect(item.name)}
                      className="custom-checkbox"
                      disabled={loadingItems[item.name]}
                    />
                  </div>
                  <div className="w-1/3 truncate flex items-center gap-2">
                    <FontAwesomeIcon
                      icon={getIconForItem(item)}
                      style={{
                        color: '#202224',
                        width: '14px',
                        height: '14px',
                      }}
                    />
                    <span
                      className={item.isFolder ? 'cursor-pointer' : ''}
                      onClick={() => item.isFolder && toggleFolder(item)}
                    >
                      {item.name}
                    </span>
                  </div>
                  <div className="w-1/6">{item.isFolder ? 'Folder' : item.type}</div>
                  <div className="w-1/6">{item.isFolder ? '--' : item.size}</div>
                  <div className="w-1/3">{item.isFolder ? '--' : item.modified}</div>
                  <div className="w-[5%]">
                    {item.isFolder ? (
                      <span className="text-gray-400">--</span>
                    ) : (
                      <span
                        className={`px-2 py-1 rounded-full text-sm font-semibold inline-block text-center ${
                          item.status === 'Encrypted' ? 'bg-green-100 text-green-600' : 'bg-orange-100 text-orange-600'
                        }`}
                      >
                        {item.status}
                      </span>
                    )}
                  </div>
                  {loadingItems[item.name] && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50">
                      <div className="spinner" style={{ width: '24px', height: '24px' }}></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {error && (
        <div style={{ textAlign: 'center', color: '#E74C3C', marginTop: '16px' }}>
          {error}
        </div>
      )}

      <Modal
        open={openModal}
        onClose={closeModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1300,
        }}
      >
        <div
          style={{
            backgroundColor: '#F7F7F7',
            padding: '20px 30px',
            borderRadius: '8px',
            width: '90vw',
            maxWidth: '500px',
            position: 'relative',
            boxShadow: '6px 6px 6px #00000040',
          }}
        >
          <div className="flex justify-between items-center mb-4">
            <h1
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '24px',
                fontWeight: 700,
                color: '#202224',
              }}
            >
              {modalMode === 'encrypt' ? 'Encryption Settings' : 'Decryption Settings'}
            </h1>
            <FontAwesomeIcon
              icon={faTimes}
              style={{
                height: '17px',
                width: '17px',
                color: '#FF7A00',
                cursor: 'pointer',
              }}
              onClick={closeModal}
            />
          </div>

          <div className="flex flex-col gap-2">
            <label
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: '#202224',
              }}
            >
              {modalMode === 'encrypt' ? 'Encryption Password*' : 'Decryption Password*'}
            </label>
            <TextField
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={modalMode === 'encrypt' ? 'Enter a strong password' : 'Enter the decryption password'}
              type="password"
              fullWidth
              sx={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                color: '#595C60',
                backgroundColor: '#FCFCFC',
                border: '0.6px solid #595C60',
                borderRadius: '6px',
                '& .MuiInputBase-input': {
                  height: '40px',
                  padding: '0 12px',
                },
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: '#FF6B00',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#FF6B00',
                  },
                },
              }}
            />
            {password && modalMode === 'encrypt' && (
              <p
                style={{
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: '12px',
                  color: '#B00020',
                  marginTop: '8px',
                }}
              >
                ⚠️ Please store your encryption password securely. If forgotten, the encrypted data cannot be recovered or decrypted.
              </p>
            )}
            {password && modalMode === 'decrypt' && (
              <p
                style={{
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: '12px',
                  color: '#B00020',
                  marginTop: '8px',
                }}
              >
                ⚠️ Ensure the password matches the one used for encryption.
              </p>
            )}
          </div>

          <div className="flex justify-end gap-4 mt-4">
            <Button
              onClick={closeModal}
              variant="outlined"
              style={{
                borderRadius: '5px',
                textTransform: 'none',
                fontSize: '14px',
                padding: '2px 16px',
                color: '#202224',
                borderColor: '#202224',
                fontFamily: 'Nunito Sans, sans-serif',
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={modalMode === 'encrypt' ? handleConfirmEncrypt : handleConfirmDecrypt}
              variant="contained"
              style={{
                backgroundColor: '#FF7A00',
                borderRadius: '5px',
                textTransform: 'none',
                fontSize: '14px',
                padding: '2px 16px',
                fontFamily: 'Nunito Sans, sans-serif',
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>

      <ConfirmDialog
        open={openDeleteConfirm}
        title="Confirm Deletion"
        message={`Are you sure you want to delete ${selectedFiles.length} selected item(s)? This action cannot be undone.`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="Delete"
        cancelText="Cancel"
        confirmButtonColor="#E74C3C"
      />
       <ConfirmDialog
        open={openRequest}
        title="Request for Deletion"
        message={`Deletion Request is sent to Admin , You Will Recieve OTP Shortly`}
        onConfirm={()=>setOpenRequest(false)}
        onCancel={()=>setOpenRequest(false)}
        confirmText="OK"
        cancelText="Cancel"
        confirmButtonColor="#FF7A00"
      />

<Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
      <style>
        {`
          .custom-checkbox {
            appearance: none;
            width: 16px;
            height: 16px;
            border: 1.5px solid #202224;
            borderRadius: 3px;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
          .custom-checkbox:checked {
            background-color: #FF7A00;
            border: none;
          }
          .custom-checkbox:checked::after {
            content: '✔';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #FFFFFF;
            fontSize: 12px;
            lineHeight: 1;
          }
          .custom-checkbox:focus {
            outline: none;
            box-shadow: 0 0 0 2px rgba(255, 122, 0, 0.3);
          }
          .custom-checkbox:disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
          .spinner {
            width: 32px;
            height: 32px;
            border: 4px solid #FF7A00;
            border-top: 4px solid transparent;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default FileExplorerCard;